export default "__VITE_ASSET__Dn8Sb4wL__"